export const TEST_ID = 'detailsViewCardApplicationList';
